import * as React from 'react';
import { StaticImage } from "gatsby-plugin-image";
import { Link } from 'gatsby';

import * as styles from '@/styles/org/about.module.scss';

const About = () => (
  <div className={styles.container}>
    <h3>書いてる人</h3>
    <div className={styles.icon}>
      <StaticImage src='../../images/boke0.svg' width={120} height={120} quality={95} alt="木瓜丸印" />
    </div>
    <p>木瓜丸です。気の赴くままに何かを作っています。</p>
    <div className={styles.linktoabout}>
      <Link to='/about'>自己紹介ページ</Link>
    </div>
  </div>
)

export default About;
